/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import Race from './Race';

/**
 * Race module exports
 */
export { Race as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/Race/index.js